import React, { useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, Box, TextField, Button,
} from '@mui/material';
import sendRequest from '../utils/sendRequest';
import { SubmitButton, CancelButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function UpdateDeliveryDateDialog({ po_doc_id, poName, addSnackbar, fetchPoDetails=null, closeMoreActions }) {
  const [open, setOpen] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState("");

  const handleOpen = () => {
    setDeliveryDate("");
    setOpen(true);
  };

  const handleClose = () => {
    if (!loadingUpdate) {
      setDeliveryDate("");
      setOpen(false);
      closeMoreActions();
    }
  };

  const updateDeliveryDate = async () => {
    setLoadingUpdate(true);
    try {
      const deliveryDateFormatted = JSON.stringify(deliveryDate);
      let response = await sendRequest(`purchase-orders/update-delivery-date?po_doc_id=${po_doc_id}&new_delivery_date=${deliveryDateFormatted}`);
      addSnackbar(response.message);
      handleClose();
      if (fetchPoDetails) fetchPoDetails();
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingUpdate(false);
    }
  }

  const handleDeliveryDateChange = (e) => {
    let value = e.target.value;
    if (value) {
      setDeliveryDate(value);
    } else {
      setDeliveryDate("");
    }
  }

  return (
    <Box>
      <Button variant="text" onClick={handleOpen}>Update Delivery Date</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown={loadingUpdate}
      >
        <CustomDialogTitle
          header={"Update Delivery Date"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>
            Update the expected delivery date for this order
          </DialogContentText>
            <TextField
              required
              margin="dense"
              id="delivery_date"
              name="delivery_date"
              label="Expected Delivery Date"
              type="date"
              fullWidth
              variant="standard"
              value={deliveryDate}
              onChange={handleDeliveryDateChange}
              InputLabelProps={{ shrink: true }}
            />
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleClose} disabled={loadingUpdate}>Cancel</CancelButton>
          <SubmitButton
            showSpinner={loadingUpdate}
            text={"Update"}
            onClick={() => updateDeliveryDate()}
            disabled={!deliveryDate.trim().length || loadingUpdate}
          />
        </DialogActions>
      </Dialog>
    </Box>
  )
}